import React from 'react';
import { PrivacyPolicyContainer } from './PrivacyStyles.styles';

// This is done
const PrivacyPolicyHeader = () => {
  return (
    <PrivacyPolicyContainer>
      <p>Last Updated: September 24, 2026</p>

      <p>
        Welcome to the Privacy Policy of Yoda Safety Services. This Privacy
        Policy explains how we collect, use, disclose, store, and protect
        personal information when you access or interact with our website,
        training platform, services, and related features, including but not
        limited to:
      </p>

      <ul>
        <li>
          Our online training portal, safety courses, quizzes, assessments,
          course progress, completion records, and certificates.
        </li>

        <li>
          Individual user accounts and company accounts, including employee
          training management, course assignments, and role-based access.
        </li>
        <li>
          Digital safety forms, completed form entries, safety manuals, and
          related workplace documentation.
        </li>
        <li>
          Subscription-based services and access to platform features and
          resources.
        </li>
        <li>
          Payments and purchases processed through Stripe or other authorized
          payment processors.
        </li>
        <li>
          Transactional emails, training notifications, newsletters, and
          promotional communications.
        </li>
        <li>
          Product, training, service, and custom documentation inquiries
          submitted through our website or directly to Yoda Safety Services.
        </li>
        <li>
          Other interactions with Yoda Safety Services through our website,
          platform, or services.
        </li>
      </ul>

      <p>
        This Privacy Policy applies to individuals who use our services,
        including individual learners, employees, company managers and
        representatives, subcontractors, and other authorized platform users.
      </p>

      <p>
        By accessing or using our website, platform, or services, you
        acknowledge the practices described in this Privacy Policy. Please
        review the full policy below to understand how your personal information
        is handled.
      </p>
    </PrivacyPolicyContainer>
  );
};

export default PrivacyPolicyHeader;
